import Model from './EpisodeWatched.schema';

export default class EpisodeWatched extends Model {}
